import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Plan } from 'constants/plan.constants';
import { intialMessage, userMessage } from 'constants/ui.constants';

interface plansState {
	loading: boolean;
	message: userMessage;
	selectedPlan: Plan | null;
	newSelectedPlan: Plan | null;
}

const initialState: plansState = {
	loading: false,
	message: intialMessage,
	selectedPlan: null,
	newSelectedPlan: null,
};

export const plansSlice = createSlice({
	name: 'plans',
	initialState,
	reducers: {
		setIsLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},
		setSelectedPlan: (state, action: PayloadAction<Plan | null>) => {
			state.selectedPlan = action.payload;
		},
		setMessage: (state, action: PayloadAction<userMessage>) => {
			state.message = action.payload;
		},
		setNewSelectedPlan: (state, action: PayloadAction<Plan | null>) => {
			state.newSelectedPlan = action.payload;
		},
	},
});

export const { setIsLoading, setSelectedPlan, setMessage, setNewSelectedPlan } = plansSlice.actions;

export const isLoading = (state: any) => state.plans.loading;
export const getMessage = (state: any) => state.plans.message;
export const getSelectedPlan = (state: any) => state.plans.selectedPlan;
export const getNewSelectedPlan = (state: any) => state.plans.newSelectedPlan;

export default plansSlice.reducer;
